import React, { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import MeetingService from 'services/MeetingService';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';
import { Attendee } from 'store/types/Meeting';
import { defaultSnackbarErrorProps } from 'util/layout';

interface VotingRoleRequestedProps extends ModalProps {
  onSubmit: () => void;
  data?: Attendee;
}

const VotingRoleRequested: React.FunctionComponent<VotingRoleRequestedProps> = ({ onClose, open, onSubmit, data }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSubmit = useCallback(() => {
    if (!data) return;

    setLoading(true);

    const updatedAttendee = {
      ...data,
      isVotingMember: true,
    };

    MeetingService.setVotingMemberAsync(updatedAttendee)
      .then(() => {
        enqueueSnackbar(`Updated interest voter`, { variant: 'success' });
        onSubmit();
      })
      .catch((error: string) => {
        enqueueSnackbar(`Failed to update interest voter`, defaultSnackbarErrorProps);
        console.error('Error updating attendee:', error);
      })
      .finally(() => setLoading(false));
  }, [data, enqueueSnackbar, onSubmit]);

  return (
    <Modal
      title={'Voting Role Requested'}
      open={open}
      maxWidth={'xs'}
      loading={loading}
      onClose={handleClose}
      onSubmit={handleSubmit}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} disabled={loading} onClick={handleClose}>
            Deny
          </Button>
          <Button type="submit" color={'primary'} variant={'contained'} disabled={!data}>
            Approve
          </Button>
        </>
      }
    >
      <p>
        <b>{data?.name}</b> would like to be the interest voter
      </p>
    </Modal>
  );
};

export default VotingRoleRequested;
